/// User will get here after entering a credit card details and this page will poll for status of the order from the server

import React from 'react';
import Parent from '../../../common/parent';
import { withTranslation } from 'react-i18next';
import logo from '../../../images/logo.svg';
import $ from 'jquery';
import { constants } from "../../../common/constants/constants";
import {BllinkLogger} from "../../../common/utils/bllink_loggers";
import {DropDown} from "../../../common/simple/dropDown";
import './planRenewalPage.css';


export class PlanRenewalsPage extends Parent {

    constructor(props) {
        super(props);
        document.title = props.t('titles.renewal_page');
        let renewalToken = this.props.match.params.renewalToken;
        this.onChanged = this.onChanged.bind(this);
        this.onMonthsForwardChanged = this.onMonthsForwardChanged.bind(this);
        this.onDeclineReasonChanged = this.onDeclineReasonChanged.bind(this);
        this.state = {
            renewalToken: renewalToken,
            selected: 'renew',
            options: this.initialOptions(),
            selectedMonthsForward: constants.FINAL_MONTH_IN_YEAR, // by default, one year forward
            selectedDecline: constants.APIContract.renewalDeclineReasons[0], // by default, one year forward
        }

    }

    initialOptions(){

        return {
            renewMonths: this.renewMonths(),
            doNotRenewReasons: this.dontRenewOptions()
        }
    }

    dontRenewOptions(){
        const {t} = this.props;
        return constants.APIContract.renewalDeclineReasons.map(reasonKey => {
            return {value: reasonKey, label: t(`payments.dont_renew_${reasonKey}`)}
        })
    }

    renewMonths(){

        let arr = Array.from({length: constants.FINAL_MONTH_IN_YEAR}, (_, index) => {
            return {
                value: index + 1,
                label: this.renewForMonthsText(index + 1)
            }
        });
        // disable 2 years since the backend still doesn't support it
        // arr.push({
        //     value: constants.FINAL_MONTH_IN_YEAR * 2,
        //     label: this.renewForMonthsText(constants.FINAL_MONTH_IN_YEAR * 2)
        // }); // 2 years
        return arr
    }

    renewForMonthsText(monthsForward, dateToday){
        const {t} = this.props;

        // removed tillMonth, requested by rayee since we don't
        // know how to consider relateToNextMonth Feature
        // when we will, we should return this data in the form
        // with consideration of the feature
        dateToday = new Date();
        let newDate = new Date(dateToday.setMonth(dateToday.getMonth()+monthsForward - 1));
        let newMonth = newDate.getMonth() + 1;
        let newYear = newDate.getFullYear();
        let tillMonthText = t(`common.months.${newMonth}`) + ' ' + newYear;
        return t('payments.renew_months_forward', {numberOfMonths: monthsForward, tillMonth: tillMonthText});
    }

    async componentDidMount() {
        // get token data
        this.startLoader();
        let renewalTokenData = await this.client.get(`/tenants/renewal/${this.state.renewalToken}`);
        let buildingData = await this.fetchBuildingData(renewalTokenData?.apartment_details.buildingID);
        this.setState({
            renewalTokenData: renewalTokenData,
            buildingData: buildingData,
            loaded: true
        })

        this.endLoader();
        this.bindClickedResponse();

    }

    bindClickedResponse(){
        // collect data selected
        // send to server
        let thisObj = this;
        $('#card_submit').unbind('click').bind('click', async function (e){
            BllinkLogger.info(`card_submit clicked `)
            e.preventDefault();

            thisObj.startLoader();
            let params = thisObj.buildRenewalResponsePayload();
            let response = await thisObj.client.post(`/tenants/renewal/${thisObj.state.renewalToken}`, params);
            BllinkLogger.info(`response renewal `, response);
            if (response.recorded){
                thisObj.setState({
                    recordedSuccessfully: true,
                    submittedPayload: params
                })
            }
            thisObj.endLoader();
        })
    }

    buildRenewalResponsePayload(){
        /*
            renew_options: {
                renew_for: {duration_in_months: 12}
                or:
                do_not_renew: {decline_reason: 'free text or from `renewalDeclineReasons`'}
            }

       */
        let params = {};
        if (this.state.selected === 'renew'){
            let numberOfMonthsForward = $('#renew-dropdown select option:selected').val();
            params.renew_for = {duration_in_months: numberOfMonthsForward}
        }else{
            let otherIsSelected = this.state.selectedDecline === 'other';
            let reason = this.state.selectedDecline;
            if (otherIsSelected){
                reason = $('.js-other-reason').val().substring(0,99) || this.state.selectedDecline;
            }
            params.do_not_renew = {decline_reason: reason}
        }
        BllinkLogger.info(`payload for renew is  `, params)
        return params;
    }

    onChanged(e){
        // flip the other radio button
        if (this.state.selected === 'renew'){
            this.setState({selected: 'do-not-renew'})
        }else{
            this.setState({selected: 'renew'})
        }
    }

    onMonthsForwardChanged(newValue){
        this.setState({selectedMonthsForward: newValue})
    }

    onDeclineReasonChanged(newValue){
        this.setState({selectedDecline: newValue})
    }

    getRelevantDetails(){

        const {t} = this.props;
        BllinkLogger.info(`this.state.renewalTokenData`, this.state.renewalTokenData)
        let tenantDetails = this.state.renewalTokenData.tenant_details;
        let data = this.state.renewalTokenData.payment_details;
        let last_4_digits = data.last_4_digits;
        let cardIssuerText, dataIssuer, fourDigitDesktop, fourDigitMobile;
        let title = this.buildingTitle(this.state.buildingData?.address, this.state.renewalTokenData.apartment_details.apartmentNumber);
        const dataIssuerServer = (data.issuer || '').toLowerCase();
        const isOfflinePayment = (constants.managerPaymentsOptions.offlinePayments.includes(dataIssuerServer))
        BllinkLogger.info(`data.issuer ${dataIssuerServer} isOfflinePayment  ${isOfflinePayment}`)
        if (isOfflinePayment) {
            cardIssuerText = <p>{t('offline_payments.type_of_payments')}</p>
            dataIssuer = <p>{t(`offline_payments.${dataIssuerServer}`)}</p>
        }else{
            fourDigitDesktop  = <p className="d-none d-md-block">{last_4_digits} **** **** ****</p>
            fourDigitMobile  = <p className="d-sm-block d-md-none">{last_4_digits} **** **** </p>

        }

        return {
            fourDigitDesktop: fourDigitDesktop, fourDigitMobile: fourDigitMobile,
            cardIssuerText: cardIssuerText, dataIssuer: dataIssuer,
            fullName: tenantDetails.name,
            title: title
        }
    }

    renderCurrentPaymentDetails(){
        const {t} = this.props;

        let result = this.getRelevantDetails();

        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12 txt_Head">
                        <h3 className="text-center">
                            {t('payments.renewal_for')}
                            <span>{t('payments.' + result.title.translationKey, result.title)}</span></h3>
                    </div>

                    <div className="mid-sec-Div d-flex">
                        <div className="col-md-6 right-para">
                            <p>{t('payments.4_last_digits')}</p>
                            <p>{t('payments.full_name')}</p>
                        </div>
                        <div className="col-md-6 left-para">
                            {result.fourDigitDesktop}{result.fourDigitMobile}{result.dataIssuer}
                            <p>{result.fullName}</p>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


    renderRenewOption(){

        const {t} = this.props;
        return (
            <div className="row form-group">
                <div className={"row"}>
                    <div className={"col-2"}>
                        <label className="label_container-2">
                                <input
                                    checked={this.state.selected === 'renew'}
                                    onChange={this.onChanged}
                                    className="js-renew"
                                    type="checkbox" />
                                <span className="checkmark-2 checkmark-renew"/>
                        </label>
                    </div>
                    <div className={"col-10 checkbox-text"}>
                        <span className={'bllink-font'}> {t('payments.renew_option') + ':'} </span>
                    </div>
                </div>


                <div className={"row"}>
                    <div id="renew-dropdown" className={"col-12 renew-dropdown"}>
                        <DropDown
                            onSelectChange={this.onMonthsForwardChanged}
                            value={this.state.selectedMonthsForward}
                            options={this.state.options.renewMonths}
                        />
                    </div>
                </div>


        </div>)
    }

    renderDontRenewOption(){
        const {t} = this.props;
        let doNotRenewSelected = this.state.selected !== 'renew';
        let doNotRenewReasonClass = doNotRenewSelected ? '': 'hidden';
        let otherIsSelected = this.state.selectedDecline === 'other'
        let freeTextInputClass = doNotRenewSelected && otherIsSelected ? '': 'hidden';

        return (<div className="row form-group">
            <div className="inline_layout-2">
                <div className={"row bllink-font"}>
                    <div className={"col-2"}>
                        <label className="label_container-2">
                            <input
                                checked={doNotRenewSelected}
                                onChange={this.onChanged}
                                className="js-do-not-renew"
                                type="checkbox" />
                            <span className="checkmark-2 checkmark-renew"/>
                        </label>
                    </div>
                    <div className={"col-10 checkbox-text"}>
                        <span className={''}> {t('payments.dont_renew_option') + ':'} </span>
                    </div>
                </div>

                <div className={"row"}>
                    <div className={"col-lg-12 col-10"}>
                        <div id="dont-renew-dropdown" className={`${doNotRenewReasonClass} renew-dropdown`}>
                                <DropDown
                                    onSelectChange={this.onDeclineReasonChanged}
                                    value={this.state.selectedDecline}
                                    options={this.state.options.doNotRenewReasons}
                                />
                        </div>
                    </div>
                    <div className={"col-lg-12 col-10"}>
                        <input type={"text"} className={`js-other-reason bllink-font bold bllink-input-border other-reason-input ${freeTextInputClass}`}/>
                    </div>
                </div>
            </div>
        </div>)
    }

    renderRenewButton(){

        const {t} = this.props;
        return (
            <div className="row form-group N_grp">
                <button id="card_submit" type="submit" className="form-control CardField-button" dir="rtl" tabIndex="5">
                    <span>{t('payments.renew_send')}</span>
                </button>
            </div>
        )
    }

    renderDecisionForm(){

        return (
            <div className="container">
                <div className="chk_card col-sm-12 col-lg-7">
                    <form className="card_from_new">
                        <div className="inner_from_Div">
                            {this.renderRenewOption()}
                            {this.renderDontRenewOption()}
                            {this.renderRenewButton()}
                        </div>
                    </form>
                </div>
            </div>
        )
    }

    renderTitleWithLogo(){
        const {t} = this.props;
        return (
            <div className="container">
                <div className="row">
                    <div className="col-md-12 last-border-line">
                        <div className="main-sec-top-c">
                            <h2>{t('payments.renewal_title')}</h2>
                            <img alt="blink" className="img-responsive" src={logo}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    renderResponseFromServer(){
        const {t} = this.props;
        let text;

        if (this.state.recordedSuccessfully){
            let chooseRenew = this.state.submittedPayload.renew_for;
            if (chooseRenew){
                text = t('payments.submitted_renew_response_successfully')
            }else{
                text = t('payments.submitted_dont_renew_response_successfully')
            }
        }else{
            text = t('payments.already_recorded_response_for_renewal')
        }

        return (
            <div className="container">
                <div className="chk_card">
                    <form className="card_from_new">
                        <div className="inner_from_Div text-center">
                            <div className="row form-group">
                                <h3>{text}</h3>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            )
    }


    render() {

        if (!this.state.loaded){
            return null;
        }

        let alreadySubmittedOrSubmittedNow = !this.state.renewalTokenData.valid || this.state.recordedSuccessfully;
        let decisionForm = alreadySubmittedOrSubmittedNow ? this.renderResponseFromServer() : this.renderDecisionForm();

        return (
            <div className="container">
                {this.renderTitleWithLogo()}

                {this.renderCurrentPaymentDetails()}

                {decisionForm}
            </div>
        )
    }
}

export default withTranslation()(PlanRenewalsPage);
